import * as React from "react";
import { RevoMenuItemButton } from "./revo-menu-item-button";
import classNames from "classnames";
import { betterServiceUrl } from "../helper/serviceurl";
import { menuItemShouldBeShown } from "../helper/scopesfromcookie";
import FlexContainer from "../grid/flexcontainer";
import Badge from "../components/badge";
import { RevoTooltip } from "../components/revo-tooltip";
export class RevoMainMenuItem extends React.PureComponent {
    decideClickAction(props) {
        return (e) => {
            const { onClick } = props;
            if (onClick) {
                e.preventDefault();
                e.stopPropagation();
                onClick();
            }
        };
    }
    render() {
        const { icon, text, active, service, path, absolutePath, scopeRequirement, logo, } = this.props;
        const classes = this.props.module
            ? ["revoMainMenu__menuItemModule"]
            : ["revoMainMenu__menuItem"];
        active &&
            classes.push(this.props.module
                ? "revoMainMenu__menuItemModule--active"
                : "revoMainMenu__menuItem--active");
        if (menuItemShouldBeShown(scopeRequirement, this.props.scopes)) {
            const serviceUrl = betterServiceUrl(service, path);
            return (React.createElement("a", { href: absolutePath ? path : serviceUrl, onClick: this.decideClickAction(this.props) },
                React.createElement("div", { className: classNames(classes) },
                    (this.props.tooltip && (React.createElement(RevoTooltip, { text: this.props.tooltip, position: "right" },
                        React.createElement(RevoMenuItemButton, { icon: icon !== null && icon !== void 0 ? icon : undefined, onClick: () => null, isImpersonating: this.props.isImpersonating })))) || (React.createElement(RevoMenuItemButton, { icon: icon !== null && icon !== void 0 ? icon : undefined, onClick: () => null, isImpersonating: this.props.isImpersonating })),
                    React.createElement("div", { className: "revoMenuItem__text" },
                        React.createElement(FlexContainer, { "md-justify": "spaceBetween" },
                            logo ? (React.createElement("div", { className: "revoMenuItem__logoTop" },
                                React.createElement("img", { src: "https://assets.21real.estate/21_logo.svg", alt: "21st RE LOGO" }))) : (React.createElement("span", { style: this.props.module
                                    ? { paddingLeft: "20px" }
                                    : { paddingLeft: "0px" } }, text)),
                            this.props.beta && (React.createElement(Badge, { size: "small", color: "secondary1" }, "BETA")))))));
        }
        else {
            return null;
        }
    }
}
//# sourceMappingURL=revo-main-menu-item.js.map